export default "/_next/static/chunks/fonts/LarsseitMedium-7b432d6501ea8e0c5eb4f41eb74a5aab.ttf";